import * as React from 'react'
import { useTheme } from '@emotion/react'

import * as Styled from './LinkButton.styles'
import Button from '../Button'
import useWindowSize from '../../hooks/useWindowSize'
import { LINK_BUTTON } from '../../utils/dataTrackingValues'
import determineButtonText from '../../utils/determineButtonText'

const LinkButton = ({
  children,
  to,
  requestId,
  CustomLink = null,
  customClasses = null,
  mobileText = null,
  visibility,
  hideCobra,
  text,
  ...props
}) => {
  const { components } = useTheme()
  const windowSize = useWindowSize()
  const buttonText = determineButtonText(
    windowSize.width,
    mobileText,
    children || text // text is for Sylex
  )
  return (
    <Styled.LinkButton
      visibility={visibility}
      hideCobra={hideCobra}
      className="leshen-link-button-wrapper"
      CustomLink={CustomLink}
      to={to}
    >
      <Button
        className={`leshen-link-button ${customClasses}`}
        rounded={components?.Button?.rounded}
        onClick={
          () => LINK_BUTTON.handleClick(children, CustomLink || to, requestId)
          // eslint-disable-next-line react/jsx-curly-newline
        }
        {...props}
      >
        {buttonText}
      </Button>
    </Styled.LinkButton>
  )
}

export default LinkButton
